import { render, staticRenderFns } from "./JIpInput.vue?vue&type=template&id=4938c583"
import script from "./JIpInput.vue?vue&type=script&lang=js"
export * from "./JIpInput.vue?vue&type=script&lang=js"
import style0 from "./JIpInput.vue?vue&type=style&index=0&id=4938c583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports